
import { useRecoilValue } from "recoil" ;
import { translationsState } from "state/ecoState";
import { TranslationMap } from "utils";

/**
 * Get translations 
 */
const useTranslation = () : TranslationMap => {
    const map = useRecoilValue(translationsState) ;
    return map
} ;

export default useTranslation;